import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export const ProjectCard = ({ project, terra = false }) => {
  const independent = project.type !== "Corporate case study";
  return (
    <Link
      to={`/work/${project.slug}`}
      data-testid={`project-card-${project.slug}`}
      className={`group flex h-full flex-col border-t-2 pt-5 ${
        terra ? "border-sand/80" : "border-ink"
      }`}
    >
      <div className="flex items-start justify-between gap-4">
        <p
          className={`text-xs font-medium uppercase tracking-[0.2em] ${
            terra ? (independent ? "text-sand" : "text-sand/60") : independent ? "text-terracotta" : "text-muted"
          }`}
        >
          {project.type}
        </p>
        <ArrowUpRight
          size={18}
          className={`shrink-0 transition-transform duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 ${
            terra ? "text-sand" : ""
          }`}
          aria-hidden="true"
        />
      </div>
      <h3
        className={`mt-5 text-2xl font-bold leading-tight tracking-tight transition-opacity duration-300 group-hover:opacity-60 ${
          terra ? "text-sand" : ""
        }`}
      >
        {project.title}
        {project.org && project.type === "Corporate case study" && (
          <span className={terra ? "text-sand/60" : "text-muted"}> — {project.org}</span>
        )}
      </h3>
      <p className={`mt-4 text-sm leading-relaxed sm:text-base ${terra ? "text-sand/75" : "text-muted"}`}>
        {project.summary}
      </p>
      <p className={`mt-5 flex items-center gap-2 text-xs ${terra ? "text-sand/70" : "text-muted"}`}>
        <span className={`h-1.5 w-1.5 rounded-full ${terra ? "bg-sand" : "bg-sage"}`} aria-hidden="true" />
        {project.status}
      </p>
      <ul className="mt-auto flex flex-wrap gap-2 pt-8">
        {project.tags.map((t) => (
          <li
            key={t}
            className={`rounded-full border px-3 py-1 text-xs ${
              terra ? "border-sand/35 text-sand/80" : "border-ink/20 text-muted"
            }`}
          >
            {t}
          </li>
        ))}
      </ul>
    </Link>
  );
};
